/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ClassroomdisciplineClassModulesIdQueryResponse,
  GetApiV1ClassroomdisciplineClassModulesIdPathParams,
  GetApiV1ClassroomdisciplineClassModulesId401,
  GetApiV1ClassroomdisciplineClassModulesId404,
  GetApiV1ClassroomdisciplineClassModulesId500,
} from "../../types/classPlanningClassModuleController/GetApiV1ClassroomdisciplineClassModulesId.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ClassroomdisciplineClassModulesId } from "../../clients/classPlanningClassModuleController/getApiV1ClassroomdisciplineClassModulesId.ts";

export const getApiV1ClassroomdisciplineClassModulesIdQueryKey = (
  id: GetApiV1ClassroomdisciplineClassModulesIdPathParams["id"],
) =>
  [
    {
      url: "/api/v1/classroomdiscipline/class-modules/:id",
      params: { id: id },
    },
  ] as const;

export type GetApiV1ClassroomdisciplineClassModulesIdQueryKey = ReturnType<
  typeof getApiV1ClassroomdisciplineClassModulesIdQueryKey
>;

export function getApiV1ClassroomdisciplineClassModulesIdQueryOptions(
  id: GetApiV1ClassroomdisciplineClassModulesIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ClassroomdisciplineClassModulesIdQueryKey(id);
  return queryOptions<
    GetApiV1ClassroomdisciplineClassModulesIdQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ClassroomdisciplineClassModulesId401
      | GetApiV1ClassroomdisciplineClassModulesId404
      | GetApiV1ClassroomdisciplineClassModulesId500
    >,
    GetApiV1ClassroomdisciplineClassModulesIdQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ClassroomdisciplineClassModulesId(id, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna o detalhe do Módulo (turmas, disciplinas, recorrências e aulas) para a tela de edição. **(Requer Authorization para autenticação)**
 * @summary Obter Módulo por ID (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/class-modules/:id}
 */
export function useGetApiV1ClassroomdisciplineClassModulesId<
  TData = GetApiV1ClassroomdisciplineClassModulesIdQueryResponse,
  TQueryData = GetApiV1ClassroomdisciplineClassModulesIdQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1ClassroomdisciplineClassModulesIdQueryKey,
>(
  id: GetApiV1ClassroomdisciplineClassModulesIdPathParams["id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ClassroomdisciplineClassModulesIdQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ClassroomdisciplineClassModulesId401
          | GetApiV1ClassroomdisciplineClassModulesId404
          | GetApiV1ClassroomdisciplineClassModulesId500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ClassroomdisciplineClassModulesIdQueryKey(id);

  const query = useQuery(
    {
      ...getApiV1ClassroomdisciplineClassModulesIdQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ClassroomdisciplineClassModulesId401
      | GetApiV1ClassroomdisciplineClassModulesId404
      | GetApiV1ClassroomdisciplineClassModulesId500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
